import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import Link from 'src/components/ui/Link'

import type { HeroCardProps } from './hero-card'
import './HeroCard.scss'

function HeroCard({ desktop, mobile, customConfiguration }: HeroCardProps) {
  const { isMobile } = useBreakpoint()
  const deviceData =
    typeof isMobile === 'undefined' ? mobile : isMobile ? mobile : desktop

  const classTitle =
    isMobile || typeof isMobile === 'undefined'
      ? customConfiguration?.alignContentHorizontallyMobile
      : customConfiguration?.alignContentHorizontallyDesktop

  const marginTop = deviceData?.marginTop
  const marginBottom = deviceData?.marginBottom

  return (
    <section
      className="herocard"
      style={{
        marginTop: `${marginTop !== '' ? marginTop : 'auto'}`,
        marginBottom: `${marginBottom !== '' ? marginBottom : 'auto'}`,
      }}
    >
      {customConfiguration?.displayTitle?.title && (
        <div
          className={`${customConfiguration?.displayTitle?.titleView} ${classTitle}`}
        >
          <h2 className={`title__flex ${classTitle}`}>
            {customConfiguration?.displayTitle?.title}
          </h2>
        </div>
      )}
      <div className={`${deviceData?.marginImage?.image} `}>
        <>
          {deviceData?.link && (
            <Link
              as="a"
              href={deviceData?.href}
              aria-label="Vai alla promozione"
            >
              <picture>
                <source media="(max-width:40em)" srcSet={mobile?.src ?? ''} />
                <source media="(min-width:40em)" srcSet={desktop?.src ?? ''} />
                <img
                  src={mobile?.src ?? ''}
                  alt={deviceData?.alt ?? 'Immagine card'}
                />
              </picture>
            </Link>
          )}
          {!deviceData?.link && (
            <picture>
              <source media="(max-width:40em)" srcSet={mobile?.src ?? ''} />
              <source media="(min-width:40em)" srcSet={desktop?.src ?? ''} />
              <img
                src={mobile?.src ?? ''}
                alt={deviceData?.alt ?? 'Immagine card'}
              />
            </picture>
          )}
        </>
      </div>
    </section>
  )
}

export default HeroCard
